<template>
  <div class="whitelist-card">
    <el-table ref="whitelistTable" class="whitelist-table mt20" :data="orderList"
              :border="false" row-key="id">

      <el-table-column prop="createtime" label="时间" align="center"/>
      <el-table-column prop="op_ip" label="操作IP" align="center"/>
      <el-table-column prop="memo" label="备注" width="500"/>

    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background layout="total, prev, pager " :total="orderTotal"
                     :current-page.sync="currentPage" :page-size="15"
                     @current-change="onPageChange"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Finance',
  data() {
    return {
      orderList: [],
      orderTotal: 0,
      maxCount: 5,
      autoReplace: false,
      searchForm: {
        page: 1,
      },
      searchLogForm: {
        order_sn: '',
        page: 1
      },
      selectedRows: [],
      pageSize: 20,
      currentPage: 1,
      whitelist: [],
      whitelistOrderSn: '',
      whitelistInput: '',

      addWhitelistForm: {
        ip: '',
        remark: ''
      },
      showLogDialog: false,
      whilteListLog: [],
      logLoading: false,
      logTotal: 0,
      whitelistTotal: 0,
      whitelistPageSize: 10,
      whitelistCurrentPage: 1,
    };
  },
  created() {
    this.getOrderList();
  },
  computed: {
    // 移除 pagedWhitelist 计算属性，直接使用 orderList
  },
  methods: {
    onPageChange(e) {
      this.searchForm.page = e
      this.getOrderList()
    },
    getOrderList() {
      this.$api.financeLog.getList(this.searchForm).then(res => {
        this.orderList = res.data.data;
        this.orderTotal = res.data.total;
      })
    },
  },
};
</script>

<style scoped>
.order-filter-card {
  background: #fff;
  box-shadow: 0 4px 24px rgba(38, 130, 255, 0.08);
  padding: 24px 24px 0 24px;
  margin-top: 20px;
}

.whitelist-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(38, 130, 255, 0.08);
  margin-top: 20px;
}

.search-filter-section {
  display: flex;
  align-items: center;
  padding: 20px;
  justify-content: space-between;
  margin-bottom: 20px;
  border-radius: 8px;
}

.search-inputs {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  width: 200px;
}

.filter-select {
  width: 150px;
}

.search-buttons {
  display: flex;
  gap: 12px;
}

.whitelist-table {
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

.whitelist-table ::v-deep tr th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 15px;
}

.whitelist-table ::v-deep tr {
  transition: background 0.2s;
}

.whitelist-table ::v-deep tr:hover td {
  background: #f0f7ff;
}

.whitelist-table ::v-deep td,
.whitelist-table ::v-deep th {
  padding: 12px 0;
}


.pagination {
  margin-top: 18px;
  text-align: right;
  padding-bottom: 18px;
}

.mt20 {
  margin-top: 20px;
}

.ml10 {
  margin-left: 10px;
}

.whitelist-dialog-small ::v-deep .el-dialog__body {
  font-size: 14px;
}

.whitelist-dialog-small ::v-deep .el-dialog__title {
  font-size: 16px;
}

.whitelist-dialog-small ::v-deep .el-table {
  font-size: 14px;
}

.whitelist-dialog-small ::v-deep .el-table th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 14px;
}

.whitelist-dialog-small ::v-deep .el-table td {
  padding: 10px 0;
  font-size: 14px;
}

@media (max-width: 900px) {
  .whitelist-card {
    padding: 12px 4px 0 4px;
  }

  .search-filter-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .search-inputs {
    flex-direction: column;
    gap: 8px;
  }

  .search-input,
  .filter-select {
    width: 100%;
  }
}
</style>
